import { useTranslation } from "react-i18next";
import "./StatsBar.css";

function StatItem({ value, label, mod }) {
  return (
    <div className="stats-bar-item">
      <span className={`stats-bar-value stats-bar-value--${mod}`}>{value}</span>
      <span className="stats-bar-label">{label}</span>
    </div>
  );
}

export default function StatsBar({ stats, size = "md" }) {
  const { t } = useTranslation();
  return (
    <div className={`stats-bar stats-bar--${size}`}>
      <StatItem value={stats.wins}   label={t("wins")}   mod="win" />
      <StatItem value={stats.draws}  label={t("draws")}  mod="draw" />
      <StatItem value={stats.losses} label={t("losses")} mod="loss" />
      <StatItem value={`${stats.goals_for}:${stats.goals_against}`} label={t("goalsRatio")} mod="goals" />
    </div>
  );
}
